/**
 * TanStack Query hooks for ingestion specs and data streams.
 */

import { useQuery } from "@tanstack/react-query"
import { ingestionApiService } from "@/services/ingestionApi"

const ingestionSpecKeys = {
  all: ["ingestion-specs"] as const,
  lists: () => [...ingestionSpecKeys.all, "list"] as const,
  list: (studyId: string | undefined) => [...ingestionSpecKeys.lists(), studyId ?? null] as const,
}

/**
 * Fetches ingestion specifications for a study.
 */
export function useIngestionSpecsList(studyId: string | undefined) {
  return useQuery({
    queryKey: ingestionSpecKeys.list(studyId),
    queryFn: () => ingestionApiService.listIngestionSpecs(studyId!),
    enabled: !!studyId,
  })
}
